import { TagValueForm } from "./TagValueForm";

export const TagValueCreate = () => {
    return <TagValueForm />;
};
